import { MarketRanking } from './components/MarketRanking';
import { useHasBeenFocusedTab } from 'shared/src/hooks';
import { Flex } from '@banhala/ui-kit';

/**
 * 임시 테스트용. 홈탭 실험이 모두 완료되면. Home.screen.tsx로 통합 될 예정
 * @constructor
 */
export const MarketRankingScreen = () => {
  const hasBeenFocused = useHasBeenFocusedTab();

  return <Flex flex={1}>{hasBeenFocused && <MarketRanking />}</Flex>;
};
